import React from 'react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="border-b border-line bg-night py-20 sm:py-24" data-id="element-21" data-mp="gvvli9ih9ake">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-22" data-mp="gxzw1aavt7tn">
        <div className="max-w-3xl" data-id="element-23" data-mp="vtxr0p92k64a">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-24" data-mp="vqtcoz1w3tzw">
            Included today at no extra cost
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-25" data-mp="14sstprcwmy2u">
            Five strategic bonuses
          </h2>
          <p className="mt-4 text-base text-white/55" data-id="element-26" data-mp="1ej49cb5yavpk">
            Real value $175 — today completely free with the system. 142
            additional position-specific drills.
          </p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="1njkc1ievdytd">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col border border-line bg-panel" data-id="element-28" data-mp="1jj9vjbtgbq09">
              <img src={bonus.cover} alt={`Cover of ${bonus.title}`} className="aspect-square w-full border-b border-line object-cover" loading="lazy" data-id="element-29" data-mp="3prwmwz30gbxx" />
              <div className="flex flex-1 flex-col p-6 sm:p-7" data-id="element-30" data-mp="2nyubz44tn72">
                <div className="flex items-center justify-between gap-4" data-id="element-31" data-mp="7ma5qea2s5re">
                  <span className="font-display text-xs font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-32" data-mp="cklbodx91w4c">
                    {bonus.number}
                  </span>
                  <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-acid" data-id="element-33" data-mp="lc3xb4cyt44t">
                    <span className="text-white/35 line-through" data-id="element-34" data-mp="qb6xaae38k5x">
                      {bonus.value}
                    </span>{' '}
                    · Free
                  </span>
                </div>
                <h3 className="mt-4 font-display text-2xl font-bold uppercase leading-none tracking-tight text-white" data-id="element-35" data-mp="1094mb03rukzl">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-36" data-mp="aj4iceb5kucz">
                  {bonus.body}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}